// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { CalendarEvent, CalendarParams } from "./types/enterpriseCoachingCalendarApiTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedEnterpriseCoachingCalendarApi = createApi({
    reducerPath: "cclTokenedEnterpriseCoachingCalendarApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCalendarEvents: builder.query<CalendarEvent[], CalendarParams>({
            query: (params) =>
                `enterprise-coaching/v1/CoachingCalendar/all-calendar-events/${params.imKey}/${params.pKey}`,
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCalendarEventsQuery } = cclTokenedEnterpriseCoachingCalendarApi;
